module.exports = __webpack_public_path__ + "static/media/anatomia.231fbdfc.png";